/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-pre-roll/menu-header-pre-roll.component.scss */
/*# sourceMappingURL=menu-header-pre-roll.component.css.map */
